import { gql } from "@apollo/client"

export const FETCH_COMPETITIONS = gql`
  query {
    competitions { id, name, footballId, code, type, emblem}
  }
`;
